import { Link, useLocation } from 'react-router-dom';
import enContent from '../../data/en-content.json';

const translatedRoutes = new Set((enContent as Array<{ route: string }>).map((entry) => entry.route));

const normalize = (pathname: string) => {
  const clean = pathname.replace(/\/+$/, '') || '/';
  return clean.startsWith('/en') ? (clean.slice(3) || '/') : clean;
};

export default function TopUtilityBar() {
  const { pathname } = useLocation();
  const isEnglish = pathname === '/en' || pathname.startsWith('/en/');
  const counterpart = normalize(pathname);
  const jaHref = counterpart;
  const enHref = translatedRoutes.has(counterpart) ? (counterpart === '/' ? '/en' : `/en${counterpart}`) : '/en';

  return (
    <div className="h-9 border-b border-amber-400/20 bg-black/95 text-xs tracking-[0.16em] text-gray-300">
      <div className="mx-auto flex h-full max-w-7xl items-center justify-end px-8" aria-label="Language selection">
        <Link to={jaHref} lang="ja" aria-current={!isEnglish ? 'page' : undefined} className={!isEnglish ? 'text-amber-400' : 'transition-colors hover:text-amber-400'}>JP</Link>
        <span className="mx-3 text-gray-600" aria-hidden="true">|</span>
        <Link to={enHref} lang="en" aria-current={isEnglish ? 'page' : undefined} className={isEnglish ? 'text-amber-400' : 'transition-colors hover:text-amber-400'}>EN</Link>
      </div>
    </div>
  );
}
